const { formatMoney } = window.BAO.Utils

class Cache {
  constructor () {
    /** @type {Map<String, String>} */
    this.cache = new Map()
  }

  exists (key) {
    return this.cache.has(key)
  }

  /**
   * @param {String} key
   * @param {String} value
   */
  set (key, value) {
    this.cache.set(key, value)
  }

  /**
   * @param {String} key
   */
  get (key) {
    return this.cache.get(key)
  }

  delete (key) {
    this.cache.delete(key)
  }
}

export class LoyaltyPointsVariant extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['data-variant-id']
  }

  static get requiredAttributes () {
    return ['data-country-code', 'data-product-handle', 'data-variant-id']
  }

  constructor () {
    super()

    this.cache = new Cache()
  }

  connectedCallback () {
    super.connectedCallback()

    this.moneyFormat = window.theme.moneyFormat
  }

  setupListeners () {
    super.setupListeners()
    /*
     * Swell (Yotpo) API will use window.jQuery to dispatch events if it is available.
     * This appears to have a compatibility issue with document.addEventLister.
     */
    if (typeof window.jQuery === 'undefined') {
      document.addEventListener('swell:setup', () => {
        this.handleCustomerDetails()
      })
    } else {
      window.jQuery(document).on('swell:setup', () => {
        this.handleCustomerDetails()
      })
    }
  }

  handleCustomerDetails () {
    this.swellAPI = window.swellAPI
    this.swellConfig = window.swellConfig

    if (!this.swellAPI || !this.swellConfig) return

    this.getProductData().then(data => {
      this.data = data

      const currentVariantPrice = this.getVariantPrice(
        data,
        this.getVariantId(this.dataset.variantId),
      )
      if (!currentVariantPrice) return

      this.showPointsAmount(parseFloat(currentVariantPrice))
    })
  }

  attributeChangedCallback (name, oldValue, newValue) {
    switch (name) {
      case 'data-variant-id': {
        if (typeof this.data === 'undefined') return

        const currentVariantPrice = this.getVariantPrice(
          this.data,
          this.getVariantId(newValue),
        )
        if (!currentVariantPrice) return

        this.showPointsAmount(parseFloat(currentVariantPrice))
      }
    }
  }

  async getProductData() {
    const response = await fetch(window.Shopify.routes.root + `products/${this.productHandle}.js`);
    const product = await response.json();
    return product;
  }  

  getVariantPrice(data, variantId) {
    const cleanVariantId = variantId.split('/').at(-1);
    const variant = data.variants.find(variant => String(variant.id) === cleanVariantId);
  
    if (this.moneyFormat.indexOf('amount_no_decimals') === -1) {
      this.moneyFormat = this.moneyFormat.replace('amount', 'amount_no_decimals');
    }
  
    const formattedMoneyPrice = formatMoney(variant.price, this.moneyFormat);
    const formattedPointsPrice = formattedMoneyPrice.replace(/[^\d.]/g, '');
  
    return formattedPointsPrice;
  }
  
  

  showPointsAmount (amount) {
    const pointsMultiplier = !isNaN(
      this.swellConfig?.customer?.vip_tier?.points_multiplier,
    )
      ? this.swellConfig?.customer?.vip_tier?.points_multiplier
      : window.theme.pointsMultiplier
    this.textContent = ((amount ?? 0.0 / 100) * pointsMultiplier).toString()
  }

  /**
   * @param {RequestInit} options
   */

  getCacheKey () {
    return `${this.countryCode}-${this.productHandle}`
  }

  getVariantId (variantId) {
    return `gid://shopify/ProductVariant/${variantId}`
  }

  get countryCode () {
    return this.dataset.countryCode
  }

  get productHandle () {
    return this.dataset.productHandle
  }
}

if (!customElements.get('loyalty-points-variant')) {
  customElements.define('loyalty-points-variant', LoyaltyPointsVariant)
}
